// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import lightbulb04Icon from "@/assets/icons/lightbulb-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Lightbulb04IconProps = Omit<IconProps, "name">;

export function Lightbulb04Icon(props: Lightbulb04IconProps): React.ReactNode {
  return <Icon name={lightbulb04Icon} {...props} />;
}
